import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserService} from '../../core/services/user.service';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {MatMenu} from '@angular/material/menu';
import {TimeService} from '../../core/services/time.service';
import {HeaderDialogComponent} from './header-dialog/header-dialog.component';
import {HeaderNotificationDialogComponent} from './header-notification-dialog/header-notification-dialog.component';
import {DialogPosition, MatDialog} from '@angular/material/dialog';

import {HttpService} from '../../core';
import {NotificationService} from "../../core/services/notification.service";

/**
 * @class HeaderComponent
 * @memberOf ThemeModule
 * @description The component controls the shared header of the system
 */
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit, AfterViewInit {
  @Input() user: any;
  @Output() private childOuter = new EventEmitter();
  @ViewChild('accountDropdown') private accountDropdown: MatMenu;
  @ViewChild('languageMenu') private languageMenu: MatMenu;

  email: string;
  highestRole: any;
  isShow: boolean;
  company: any;
  SERVER_URL = environment.SERVER_URL;
  unreadNotificationCount: number;


  constructor(private userService: UserService,
              private router: Router,
              // private languageService: LanguageService,
              // public translate: TranslateService,
              public timeService: TimeService,
              private httpService: HttpService,
              public dialog: MatDialog,
              public notificationService: NotificationService) {
    this.isShow = false;
  }


  ngOnInit(): void {
    this.httpService.getInfo().subscribe((res1: any) => {
      this.user = res1.data;
    });
    // console.log('user', this.user);
    this.notificationService.checkUnreadNotification().then(() => {
      this.unreadNotificationCount = this.notificationService.unreadNotificationCount;
      console.log('---count---', this.unreadNotificationCount);
    });
    this.notificationService.unreadNotificationCountSubject.subscribe((count: number) => {
      this.unreadNotificationCount = count;
      console.log('---count---', this.unreadNotificationCount);
    });
  }

  ngAfterViewInit(): void {
  }

  toggleSideNav() {
    this.childOuter.emit(!this.isShow);
  }

  openDetailDialog() {
    const dialogRef = this.dialog.open(HeaderDialogComponent, {
      height: '100%',
      width: '400px',
      panelClass: ['animate__animated', 'animate__slideInRight', 'animate__faster'],
      position: {right: '0'},
      autoFocus: false,
      data: {
        user: this.user
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.ngOnInit();
        // this.user = result
      }
    });

  }


  handleToNotification() {
    this.dialog.open(HeaderNotificationDialogComponent, {
      height: '100%',
      panelClass: ['animate__animated', 'animate__slideInRight', 'animate__faster'],
      position: {right: '0'},
      autoFocus: false,
    });
  }

  handleInput(e) {
    // this.router.navigaste(['/projects/'], { queryParams: { key: e.target.value } })
  }

  handleToHome() {
    this.router.navigate(['/projects']);
  }


  // logout() {
  //     this.userService.logOut().subscribe((res: any) => {
  //         if (res.code === 1) {
  //             this.router.navigate(['/auth/login']);
  //         } else {
  //             console.log('Logout Failure');
  //         }
  //     });
  // }


}
